import {debounce} from 'debounce';
import imagesLoaded from 'imagesloaded';

const setHexagonStyle = (pane, image) => {
	const height = image.getBoundingClientRect().height;
	const panePaddingTop = parseInt(window.getComputedStyle(pane).getPropertyValue('padding-top'));

	pane.style.setProperty('--hexagon-height', `${(height / 3) * 1.75 + panePaddingTop}px`);
};

[...document.querySelectorAll('.pane--hexagon')].forEach((pane) => {
	const firstImage = pane.querySelector('img');
	if (!firstImage) return;

	firstImage.onload = () => setHexagonStyle(pane, firstImage);

	window.addEventListener(
		'resize',
		debounce(() => {
			setHexagonStyle(pane, firstImage);
		}, 200)
	);

	imagesLoaded(pane, () => setHexagonStyle(pane, firstImage));
});

const setSkewStyle = (pane, image) => {
	const {y: paneY} = pane.getBoundingClientRect();
	const {y: imageY, height: imageHeight} = image.getBoundingClientRect();
	const imageDistanceToPane = imageY - paneY;

	pane.style.setProperty('--skew-height', `${imageDistanceToPane + imageHeight / 2}px`);
};

[...document.querySelectorAll('.pane--skew')].forEach((pane) => {
	const image = pane.querySelector('img');
	if (!image) return;

	window.addEventListener(
		'resize',
		debounce(() => {
			setSkewStyle(pane, image);
		}, 200)
	);

	imagesLoaded(image, () => setSkewStyle(pane, image));
});
